import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiXCircle, FiAlertCircle, FiDatabase, FiClock } = FiIcons;

const StatusHealth = ({ healthStatus }) => {
  if (!healthStatus) return null;

  const getSourceStatus = (isAvailable, errors = 0) => {
    if (!isAvailable || errors > 2) {
      return { icon: FiXCircle, color: 'text-red-500', status: 'Offline' };
    } else if (errors > 0) {
      return { icon: FiAlertCircle, color: 'text-yellow-500', status: 'Issues' };
    }
    return { icon: FiCheckCircle, color: 'text-green-500', status: 'Online' };
  };

  const sources = [
    { name: 'USGS', ...getSourceStatus(healthStatus.sources.usgs, healthStatus.errorCount) },
    { name: 'GDACS', ...getSourceStatus(healthStatus.sources.gdacs) },
    { name: 'PAGASA', ...getSourceStatus(healthStatus.sources.pagasa) },
    { name: 'Tidal', ...getSourceStatus(healthStatus.sources.tidal) },
    { name: 'Flood', ...getSourceStatus(healthStatus.sources.flood) },
    { name: 'PHIVOLCS', ...getSourceStatus(healthStatus.sources.phivolcs) },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-md p-4"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">System Status</h3>
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiDatabase} className="text-gray-500" />
          <span className="text-sm text-gray-600">
            Cache: {healthStatus.cacheSize} items
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 mb-4">
        {sources.map(source => (
          <div key={source.name} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={source.icon} className={`${source.color}`} />
              <span className="font-medium">{source.name}</span>
            </div>
            <span className={`text-sm ${source.color}`}>
              {source.status}
            </span>
          </div>
        ))}
      </div>

      {healthStatus.lastUpdate && (
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <SafeIcon icon={FiClock} />
          <span>
            Last updated: {new Date(healthStatus.lastUpdate).toLocaleString('en-PH', { timeZone: 'Asia/Manila' })} PHT
          </span>
        </div>
      )}
    </motion.div>
  );
};

export default StatusHealth;